import { Model } from "./model";

import { Product } from "./product.model";

export class ProductCategory extends Model {
    id: number;
    parent_id: number;
    name: string;
    translation?: string;
    children?: ProductCategory[];
    products?: Product[];
}


// WEBPACK FOOTER //
// ./src/models/product-category.model.ts